import { api } from '@/lib/api';
import type {
  IApiResponse,
  ISonarqubeListFilters,
  ISonarqubeProject,
  ISonarqubeProjectQualityHistory,
  ISonarqubeProjectQualityLatest,
} from '@skystone/shared';
import { buildListEndpoint } from './list-query';

function sonarqubeEndpoint(path: string, filters?: ISonarqubeListFilters): string {
  return buildListEndpoint(path, [
    ['limit', filters?.limit],
    ['offset', filters?.offset],
  ]);
}

export const sonarqubeApi = {
  getProjects: async (filters?: ISonarqubeListFilters): Promise<ISonarqubeProject[]> => {
    const endpoint = sonarqubeEndpoint('/sonarqube/projects', filters);
    const result = await api.get<IApiResponse<ISonarqubeProject[]>>(endpoint);
    return result.data;
  },

  getQualityLatest: async (filters?: ISonarqubeListFilters): Promise<ISonarqubeProjectQualityLatest[]> => {
    const endpoint = sonarqubeEndpoint('/sonarqube/quality-latest', filters);
    const result = await api.get<IApiResponse<ISonarqubeProjectQualityLatest[]>>(endpoint);
    return result.data;
  },

  getQualityHistory: async (filters?: ISonarqubeListFilters): Promise<ISonarqubeProjectQualityHistory[]> => {
    const endpoint = sonarqubeEndpoint('/sonarqube/quality-history', filters);
    const result = await api.get<IApiResponse<ISonarqubeProjectQualityHistory[]>>(endpoint);
    return result.data;
  },
};
